// ========================================
// Hook לניהול נתוני המלאי מהענן
// ========================================
import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export const useInventory = (user) => {
    const [items, setItems] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // פונקציה לשליפת הנתונים
    const fetchInventory = useCallback(async () => {
        try {
            setIsLoading(true);

            // שליפה מ-Supabase
            const { data, error: dbError } = await supabase
                .from('inventory_items')
                .select('*');

            if (dbError) throw dbError;

            // אם אין נתונים בכלל (מערכת ריקה)
            if (!data || data.length === 0) {
                setItems(null);
                return;
            }

            // המרה מפורמט DB (snake_case) לפורמט האפליקציה (PascalCase)
            // כמו ש-FileUploader היה עושה
            const formattedItems = data.map(item => ({
                SKU: item.sku,
                Description: item.description,
                PhysicalStock: item.physical_stock,
                OnOrder: item.on_order,
                Velocity: item.velocity,
                AvgDailySales: Number(item.avg_daily_sales),
                Classification: item.classification,
                // שדות מחושבים יתווספו בדשבורד כרגיל
            }));

            setItems(formattedItems);
            setError(null);

        } catch (err) {
            console.error('Error fetching inventory:', err);
            setError('שגיאה בטעינת נתוני המלאי מהענן');
        } finally {
            setIsLoading(false);
        }
    }, [user]);

    // שליפה ראשונית בטעינת ה-Hook
    useEffect(() => {
        if (user) {
            fetchInventory();
        } else {
            setItems(null);
            setIsLoading(false);
        }
    }, [user, fetchInventory]);

    return {
        items,
        isLoading,
        error,
        refetch: fetchInventory
    };
};
